import pipe from "../lib/core/functional/pipe";
import { map, filter, flatMap } from "../lib/core/functional/curriedArray";
import queryAllDOM from "../utils/queryAllDOM";

/**
 * @param {HTMLElement} nextPageWrapper
 * @returns {string}
 */
const getExcludedPostIds = (nextPageWrapper) =>
    pipe(getIgnoredSourceIds, getPostIdsFromDom)(nextPageWrapper);

/**
 * @param {HTMLElement} nextPageWrapper
 * @returns {Set<string>}
 */
const getIgnoredSourceIds = (nextPageWrapper) =>
    shouldIgnorePageNumber(nextPageWrapper)
        ? new Set()
        : new Set((nextPageWrapper.dataset.postsSources || "").split(","));

/**
 * @param {HTMLElement} nextPageWrapper
 * @returns {boolean}
 */
const shouldIgnorePageNumber = (nextPageWrapper) =>
    nextPageWrapper.dataset.ignorePageNumber === "true";

/**
 * @param {Set<string>} ignoredSourceIds
 * @returns {string[]}
 */
const getPostIdsFromDom = (ignoredSourceIds) =>
    pipe(
        queryAllDOM("[data-source]"),
        filter((element) => element.getAttribute("data-source-unique") !== "false"),
        filter((element) => !ignoredSourceIds.has(element.getAttribute("data-source"))),
        flatMap(queryAllDOM("[elid]")),
        map((element) => element.getAttribute("elid"))
    )(document);

/**
 * @param {HTMLElement} nextPageWrapper
 * @param context
 * @returns {{sklId: string, bootstrap: *, path: string, pathParams: *, excludePostIds: string, ignorePageNumber: boolean}}
 */
export default function makeTransportContext(nextPageWrapper, context) {
    const articles = Array.from(nextPageWrapper.parentElement.querySelectorAll("article"));
    const lastArticle = articles[articles.length - 1];
    const lastPostId = lastArticle ? lastArticle.getAttribute("elid") : "";

    const postIds = getExcludedPostIds(nextPageWrapper);
    const uniqueIds = new Set(postIds);

    return {
        sklId: nextPageWrapper.dataset.sklId,
        bootstrap: context.settings,
        path: context.path,
        pathParams: context.pathParams,
        excludePostIds: Array.from(new Set(uniqueIds)).sort().join(","),
        ignorePageNumber: shouldIgnorePageNumber(nextPageWrapper),
        lastPostId: lastPostId,
    };
}
